export default __webpack_public_path__ + "static/media/1988.22d94127.png";